// extracted by mini-css-extract-plugin
export var numpadContainer = "_pe-1";
export var phoneButton = "_pe-0";